import type { Phase } from '../../types/domain';

/* Phase annulée (clôturée avant de commencer, arbitrage du 05/10/2026) : ses dates prévues sont
   gardées pour l'affichage ; dans les calculs, sa fin effective reste sa date d'annulation,
   antérieure à son début, ce qui l'exclut du planifié, du consommé et du CA comme avant. */
export function isCancelledPhase(phase: Phase): boolean {
  return !!phase.annuleeLe;
}

// Fin prévue, à afficher et à proposer dans la fiche de la phase.
export function plannedEnd(phase: Phase): string | null {
  return (isCancelledPhase(phase) ? phase.dateFinPrevue : phase.dateFin) || null;
}

// Phase de l'application depuis sa fin prévue (base) et sa date d'annulation.
type CancellationFields = Pick<Phase, 'dateFin' | 'dateFinPrevue' | 'annuleeLe'>;

export function withCancellation<T extends Omit<Phase, keyof CancellationFields>>(
  phase: T,
  storedEnd: string | null,
  annuleeLe: string | null,
): T & CancellationFields {
  if (!annuleeLe) return { ...phase, dateFin: storedEnd, dateFinPrevue: null, annuleeLe: null };
  return { ...phase, dateFin: annuleeLe, dateFinPrevue: storedEnd, annuleeLe };
}
